<template>
  <v-navigation-drawer
  v-model="drawer"
  fixed
  width="900px"
  class="foreground"
  style="z-index: 9;"
  temporary
  stateless
  >

    <v-sheet :key="componentKey" class="foreground" style="display: flex; flex-direction: column; height: 100%;">

      <v-row class="align-center c-flex-00a border-b--thin pa-2">
        <v-spacer></v-spacer>
        <v-btn
        icon
        large
        class="ml-2"
        @click="drawer = !drawer"
        >
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </v-row>

      <!-- MAIN SCROLLING AREA -->
      <v-sheet style="overflow: auto; flex: 1;">

        <v-bottom-navigation
        v-model="activeTab"
        color="color1"
        horizontal
        >
          <v-btn>
            <span>NAME</span>
            <v-icon>mdi-package-variant</v-icon>
          </v-btn>

          <v-btn>
            <span>CODE</span>
            <v-icon>mdi-qrcode-scan</v-icon>
          </v-btn>

        </v-bottom-navigation>

        <!-- MAIN CONTENT -->
        <keep-alive>
          <name-search-combo :url="url" :urlArgs="urlArgs" v-if="url.split('/')[0] === 'name-search'" ref="nameSearch" @redirect="redirect" :key="drawer + 'a'"></name-search-combo>
          <code-search :url="url" :urlArgs="urlArgs" v-else-if="url.split('/')[0] === 'code-search'" ref="codeSearch" @redirect="redirect" :key="drawer + 'b'"></code-search>
        </keep-alive>
        <!-- MAIN CONTENT -->

      </v-sheet>

    </v-sheet>

  </v-navigation-drawer>
</template>

<script>
import NameSearchCombo from './views/name-search-combo/Main'
import CodeSearch from './views/code-search/Main'

export default {
  components: {
    NameSearchCombo,
    CodeSearch
  },
  data () {
    return {
      url: 'name-search',
      urlArgs: {},
      drawer: false,
      componentKey: 0
    }
  },
  computed: {
    activeTab: {
      get () {
        if (this.url === 'code-search') {
          return 1
        } else {
          return 0
        }
      },
      set (nv) {
        if (nv === 0) {
          this.url = 'name-search'
        } else if (nv === 1) {
          this.url = 'code-search'
        }
      }
    }
  },
  methods: {
    toggle () {
      if (!this.drawer) {
        this.componentKey++
      }
      this.drawer = !this.drawer
      if (this.drawer) {
        this.onDrawerOpen()
      }
    },
    onDrawerOpen () {
      if (this.url === 'name-search') {
        this.$refs.nameSearch.onOpenDrawer()
      } else if (this.url === 'code-search') {
        this.$refs.codeSearch.onOpenDrawer()
      }
    },
    getTab (_url) {
      var url = _url.split('/')[0] 
      switch (url) {
        case 'name-search': return this.$refs.nameSearch
        case 'code-search': return this.$refs.codeSearch
        default: return this.$refs.nameSearch
      }
    },
    redirect (url, args) {
      this.url = url
      this.urlArgs = args
    }
  },
  created () {
    
  }
}
</script>